var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getUserStatusCGI, getOpenAccountInfoCGI, OpenAccountState, getCardListCGI } from './data';
import { getLang } from '../i18n/tools';
import { invoke, loginInfoUtil, navigator } from '@tencent/vb-app-bridge';
import { modal } from '@tencent/web-vbui/src/components/t-modal/modal';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { to, isFusionBankApp } from '@tencent/vb-web-base-core';
import { t } from './locales/index';
var curLang = '';
export var RESULTCODE;
(function (RESULTCODE) {
    RESULTCODE[RESULTCODE["SUCCESS"] = 0] = "SUCCESS";
    RESULTCODE[RESULTCODE["NOLOGIN"] = 1] = "NOLOGIN";
    RESULTCODE[RESULTCODE["NOACTIVE"] = 2] = "NOACTIVE";
    RESULTCODE[RESULTCODE["NOACCOUNT"] = 3] = "NOACCOUNT";
    RESULTCODE[RESULTCODE["LOGINRELOAD"] = 4] = "LOGINRELOAD";
    RESULTCODE[RESULTCODE["OPENACCOUNTING"] = 5] = "OPENACCOUNTING";
    RESULTCODE[RESULTCODE["CLOSEACCOUNT"] = 6] = "CLOSEACCOUNT";
    RESULTCODE[RESULTCODE["NOACCOUNTANDCREATE"] = 7] = "NOACCOUNTANDCREATE";
    RESULTCODE[RESULTCODE["NOACTIVETOACTIVE"] = 8] = "NOACTIVETOACTIVE";
    RESULTCODE[RESULTCODE["ERROR"] = 9] = "ERROR";
})(RESULTCODE || (RESULTCODE = {}));
function statusMap(status) {
    var statusData = {
        code: RESULTCODE.SUCCESS,
        message: 'UNKNOWN',
    };
    switch (status) {
        case 0:
            statusData.code = RESULTCODE.NOLOGIN;
            statusData.message = 'NOLOGIN';
            break;
        case 1:
            statusData.code = RESULTCODE.NOACCOUNT;
            statusData.message = 'NOACCOUNT';
            break;
        case 2:
            statusData.code = RESULTCODE.NOACTIVE;
            statusData.message = 'NOACTIVE';
            break;
        default:
            statusData.code = RESULTCODE.SUCCESS;
            statusData.message = 'SUCCESS';
            break;
    }
    return statusData;
}
export function JumpLogin() {
    return __awaiter(this, void 0, void 0, function () {
        var sessionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loginInfoUtil.logout();
                    return [4 /*yield*/, invoke({
                            path: '/Login',
                        }, {
                            target: 'native',
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loginInfoUtil.getSessionId()];
                case 2:
                    sessionId = _a.sent();
                    return [2 /*return*/, sessionId];
            }
        });
    });
}
export function showOpenAccountDialog(status) {
    return __awaiter(this, void 0, void 0, function () {
        var content, modalResp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    content = '';
                    switch (status) {
                        case RESULTCODE.NOACCOUNT:
                            content = t('您的银行户口尚未开通。', curLang);
                            break;
                        case RESULTCODE.OPENACCOUNTING:
                            content = t('您的银行户口审核中。', curLang);
                            break;
                        case RESULTCODE.CLOSEACCOUNT:
                            content = t('当前户口销户中，请耐心等待', curLang);
                            break;
                    }
                    return [4 /*yield*/, modal.show({
                            title: t('温馨提示', curLang),
                            content: content,
                            // 只有未开通时展示立即开通
                            confirmText: isFusionBankApp && status === RESULTCODE.NOACCOUNT ? t('立即开通', curLang) : '',
                            cancelText: t('我知道了', curLang),
                        })];
                case 1:
                    modalResp = _a.sent();
                    if (modalResp === 'confirm') {
                        if (status === RESULTCODE.NOACCOUNT) {
                            navigator.push({
                                path: '/e/my/open.html?__isShowNav=0&__bgColor=FF2F2B32',
                            }, {
                                target: 'weex',
                                isShowNav: false,
                            });
                            return [2 /*return*/, true];
                        }
                    }
                    return [2 /*return*/, false];
            }
        });
    });
}
export function showActiveDialog() {
    return __awaiter(this, void 0, void 0, function () {
        var content, modalResp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    content = t('受金管局监管要求，您需通过本人户口存入500以上金额的港币方能使用本户口', curLang);
                    return [4 /*yield*/, modal.show({
                            title: t('温馨提示', curLang),
                            content: content,
                            confirmText: isFusionBankApp ? t('立即激活', curLang) : '',
                            cancelText: t('我知道了', curLang),
                        })];
                case 1:
                    modalResp = _a.sent();
                    if (!(modalResp === 'confirm')) return [3 /*break*/, 3];
                    return [4 /*yield*/, onJumpActiveGuide()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3: return [2 /*return*/, false];
            }
        });
    });
}
export function onJumpActiveGuide() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, cardList, err;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(getCardListCGI())];
                case 1:
                    _a = _b.sent(), cardList = _a[0], err = _a[1];
                    if (err) {
                        modal.show({
                            title: t('温馨提示', curLang),
                            content: [err.message, "(".concat(t('错误码：', curLang)).concat(err.code, ")")],
                            confirmText: t('我知道了', curLang),
                            cancelText: '',
                        });
                        return [2 /*return*/, false];
                    }
                    if (cardList.length > 0) {
                        navigator.push({
                            path: '/e/basic/deposit/current/save.html',
                        }, {
                            target: 'weex',
                            isShowNav: false,
                        });
                    }
                    else {
                        navigator.push({
                            path: '/e/basic/deposit/current/guide.html',
                        }, {
                            target: 'weex',
                            isShowNav: false,
                        });
                    }
                    return [2 /*return*/, true];
            }
        });
    });
}
var responseData = {
    code: 0,
    message: 'SUCCESS',
};
export function accountCheck(parame) {
    return __awaiter(this, void 0, void 0, function () {
        var localSessionId, _a, statusInfo, error, _b, curUrlObject, sessionId, recheckStatus, _c, openAccountInfo, error, openStatus, resp;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    parame = parame || {};
                    return [4 /*yield*/, getLang()];
                case 1:
                    curLang = _d.sent();
                    localSessionId = '';
                    if (!isFusionBankApp) return [3 /*break*/, 3];
                    return [4 /*yield*/, loginInfoUtil.getSessionId()];
                case 2:
                    localSessionId = (_d.sent()) || '';
                    return [3 /*break*/, 4];
                case 3:
                    localSessionId = 'noInApp';
                    _d.label = 4;
                case 4:
                    if (!!localSessionId) return [3 /*break*/, 5];
                    responseData = statusMap(0);
                    return [3 /*break*/, 9];
                case 5:
                    spin.show();
                    return [4 /*yield*/, to(getUserStatusCGI())];
                case 6:
                    _a = _d.sent(), statusInfo = _a[0], error = _a[1];
                    spin.hide();
                    if (!error) return [3 /*break*/, 8];
                    return [4 /*yield*/, modal.show({
                            title: t('温馨提示', curLang),
                            content: [error.message, "(".concat(t('错误码：', curLang)).concat(error.code, ")")],
                            confirmText: t('我知道了', curLang),
                            cancelText: '',
                        })];
                case 7:
                    _d.sent();
                    responseData.code = RESULTCODE.ERROR;
                    responseData.message = 'getUserStatusError';
                    return [2 /*return*/, responseData];
                case 8:
                    responseData = statusMap(statusInfo.status);
                    _d.label = 9;
                case 9:
                    _b = responseData.code;
                    switch (_b) {
                        case RESULTCODE.NOLOGIN: return [3 /*break*/, 10];
                        case RESULTCODE.NOACCOUNT: return [3 /*break*/, 14];
                        case RESULTCODE.NOACTIVE: return [3 /*break*/, 17];
                    }
                    return [3 /*break*/, 22];
                case 10:
                    if (parame.needAutoLogin === false || !isFusionBankApp) {
                        return [2 /*return*/, responseData];
                    }
                    curUrlObject = new URL(window.location.href);
                    return [4 /*yield*/, JumpLogin()];
                case 11:
                    sessionId = _d.sent();
                    if (!sessionId) return [3 /*break*/, 13];
                    if (parame.loginReload === true) {
                        // reload在安卓机上无效 奇葩
                        // window.location.reload();
                        curUrlObject.searchParams.set('reloadTag', '1');
                        responseData.code = RESULTCODE.LOGINRELOAD;
                        responseData.message = 'LOGINRELOAD';
                        window.location.href = curUrlObject.href;
                        return [2 /*return*/, responseData];
                    }
                    return [4 /*yield*/, accountCheck(parame)];
                case 12:
                    recheckStatus = _d.sent();
                    return [2 /*return*/, recheckStatus];
                case 13: return [2 /*return*/, responseData];
                case 14:
                    spin.show();
                    return [4 /*yield*/, to(getOpenAccountInfoCGI())];
                case 15:
                    _c = _d.sent(), openAccountInfo = _c[0], error = _c[1];
                    spin.hide();
                    if (error) {
                        return [2 /*return*/, responseData];
                    }
                    switch (openAccountInfo.state) {
                        case OpenAccountState.OPENACCOUNT_STATE_WAIT:
                        case OpenAccountState.OPENACCOUNT_STATE_CHECKING:
                        case OpenAccountState.OPENACCOUNT_STATE_CHECK_PASS:
                            responseData.code = RESULTCODE.OPENACCOUNTING;
                            responseData.message = 'OPENACCOUNTING';
                            break;
                        case OpenAccountState.CLOSEACCOUNT:
                            responseData.code = RESULTCODE.CLOSEACCOUNT;
                            responseData.message = 'CLOSEACCOUNT';
                            break;
                    }
                    if (parame.needOpenModal === false) {
                        return [2 /*return*/, responseData];
                    }
                    return [4 /*yield*/, showOpenAccountDialog(responseData.code)];
                case 16:
                    openStatus = _d.sent();
                    // 点击去开户了
                    if (openStatus === true) {
                        responseData.code = RESULTCODE.NOACCOUNTANDCREATE;
                        responseData.message = 'NOACCOUNTANDCREATE';
                    }
                    return [2 /*return*/, responseData];
                case 17:
                    resp = false;
                    if (!(parame.needActivateModal === false)) return [3 /*break*/, 19];
                    return [4 /*yield*/, onJumpActiveGuide()];
                case 18:
                    resp = _d.sent();
                    return [3 /*break*/, 21];
                case 19: return [4 /*yield*/, showActiveDialog()];
                case 20:
                    resp = _d.sent();
                    _d.label = 21;
                case 21:
                    if (!resp) {
                        return [2 /*return*/, responseData];
                    }
                    responseData.code = RESULTCODE.NOACTIVETOACTIVE;
                    responseData.message = 'NOACTIVETOACTIVE';
                    return [2 /*return*/, responseData];
                case 22: return [2 /*return*/, responseData];
            }
        });
    });
}
